import { Color } from "@material-ui/lab";

export class CcpAlert {
    constructor(public message: string, public type: Color, public timeout?: number) {}
}
